import Roles from "../config/roles";


class OrderStates {

    static states = ["Sin preparar", "En preparación", "Preparado", "En revisión"];

    // Mapeo de estados para uso directo
    static ESTADOS_MAP = {
        '1': 'Sin preparar',
        '2': 'En preparación',
        '3': 'Preparado',
        '4': 'En revisión'
    };

    static getStatesJson() {
        return [{label: this.states[0], value: 1}, {label: this.states[1], value: 2}, {label: this.states[3], value: 4}, {label: this.states[2], value: 3}];
    }

    static getStatesJsonRole(roles) {

        if (roles.includes(Roles.ADMIN.role)) {
            return this.getStatesJson();
        }

        if (roles.includes(Roles.ALMACEN.role)) {
            return [
                {label: this.states[1], value: 2},
                {label: this.states[2], value: 3}
            ];
        }

        return [
            {label: this.states[1], value: 2}
        ];
    }

    // Un estado fuera de rango cae al valor crudo en vez de a undefined: hay
    // consumidores que encadenan sobre el resultado (Orders.js hace .toLowerCase())
    // y un undefined ahí es un TypeError, no una etiqueta vacía.
    static getState(state) {
        return this.states[state - 1] ?? String(state ?? "");
    }
}

export default OrderStates;